var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4C18.1046 4 19 4.89543 19 6V8H21C22.1046 8 23 8.89543 23 10V18C23 19.1046 22.1046 20 21 20H7L6.7959 19.9893C5.78722 19.887 5 19.0357 5 18V16H3L2.7959 15.9893C1.78722 15.887 1 15.0357 1 14V6C1 4.89543 1.89543 4 3 4H17ZM19 14C19 15.1046 18.1046 16 17 16H7V18H21V10H19V14ZM7 14H9.58594L7 11.4141V14ZM12.4141 14H15.5859L11.5859 10H8.41406L12.4141 14ZM3 14H5V10C5 8.89543 5.89543 8 7 8H17V6H3V14ZM17 12.5859V10H14.4141L17 12.5859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay);
export default __webpack_public_path__ + "static/media/Overlay.c48c6e6308495102737cf31e72a8af80.svg";
export { ForwardRef as ReactComponent };